module.exports = __webpack_public_path__ + "img/advantage-4.f682d47d.png";